/**
 * Type that references another type.
 */
 module.exports = function() {};